module.exports = __webpack_public_path__ + "static/media/cmct-cat-promo-edited.cfbc72cb.png";